import _extends from "@babel/runtime/helpers/extends";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["trade", "skill", "restApiHostname"];
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

import React, { useEffect, useReducer } from 'react';
import axios from 'axios';
import isEmpty from 'lodash-es/isEmpty';
import get from 'lodash-es/get';
import { formatTradesAndSkills, getSkillsOptionsForTrade } from '@ratedpeople/utils';
import DefaultLayout from './layouts/DefaultLayout';
import style from './style.module.scss';

var genericReducer = function genericReducer(state, update) {
  return _objectSpread(_objectSpread({}, state), update);
};

var defaultProps = {
  trade: '',
  skill: '',
  basePath: '',
  inlineStyleJobFormArea: {},
  contentTexts: {},
  theme: 'default',
  inputTheme: 'default',
  inputErrorTheme: 'inverted',
  backgroundImages: [],
  flexDirection: 'column',
  flexJustify: 'start',
  buttonText: 'Next step',
  hasPopularTrades: true,
  buttonFill: true,
  showCancelButton: false,
  cancelCallback: function cancelCallback() {}
};
var instances = -1;

var JobFormEntry = function JobFormEntry(_ref) {
  var trade = _ref.trade,
      skill = _ref.skill,
      restApiHostname = _ref.restApiHostname,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var _useReducer = useReducer(genericReducer, {
    tradesData: {},
    trade: trade,
    skill: skill,
    tradeError: false,
    skillError: false,
    tradeOptions: [],
    skillsOptions: [],
    backgroundImages: props.backgroundImages
  }),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  useEffect(function () {
    instances++;

    var fetchTradesAndSkills = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var tradesAndSkillsEndpoint, _yield$axios$get, tradesData, _formatTradesAndSkill, initialTrade, initialSkill, tradeOptions, skillsOptions, errorMsg;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              tradesAndSkillsEndpoint = restApiHostname + "/trades-and-skills";
              _context.prev = 1;
              _context.next = 4;
              return axios.get(tradesAndSkillsEndpoint);

            case 4:
              _yield$axios$get = _context.sent;
              tradesData = _yield$axios$get.data;
              _formatTradesAndSkill = formatTradesAndSkills(tradesData, trade, skill, props.hasPopularTrades), initialTrade = _formatTradesAndSkill.initialTrade, initialSkill = _formatTradesAndSkill.initialSkill, tradeOptions = _formatTradesAndSkill.tradeOptions, skillsOptions = _formatTradesAndSkill.skillsOptions;
              dispatch({
                tradesData: tradesData,
                trade: initialTrade,
                skill: initialSkill,
                tradeOptions: tradeOptions,
                skillsOptions: skillsOptions
              });
              _context.next = 14;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](1);
              errorMsg = get(_context.t0, 'response.data.error.message', false) || "Could not get trades and skills from " + tradesAndSkillsEndpoint;
              console.log('ERROR', errorMsg);

            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[1, 10]]);
      }));

      return function fetchTradesAndSkills() {
        return _ref2.apply(this, arguments);
      };
    }();

    fetchTradesAndSkills(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  var onChange = function onChange(e) {
    var _dispatch;

    var _e$target = e.target,
        name = _e$target.name,
        value = _e$target.value;
    dispatch((_dispatch = {}, _dispatch[name] = value, _dispatch[name + "Error"] = isEmpty(value), _dispatch));
  };

  var onTradeChange = function onTradeChange(e) {
    onChange(e);
    var trade = e.target.value;
    var skillsOptions = getSkillsOptionsForTrade(trade, state.tradesData);
    dispatch({
      skillsOptions: skillsOptions,
      skill: ''
    });
  };

  var onSubmit = function onSubmit(e) {
    e.preventDefault();
    var trade = state.trade,
        skill = state.skill;
    var tradeError = isEmpty(trade);
    var skillError = isEmpty(skill);

    if (tradeError || skillError) {
      dispatch({
        tradeError: tradeError,
        skillError: skillError
      });
      return;
    }

    var url = props.basePath + "/" + trade + "/" + skill;
    window.location.assign(url);
  };

  return /*#__PURE__*/React.createElement("form", {
    className: style.form,
    noValidate: true,
    onSubmit: onSubmit,
    "data-test": "job-form-entry"
  }, /*#__PURE__*/React.createElement(DefaultLayout, _extends({
    instance: instances,
    onChange: onChange,
    onTradeChange: onTradeChange,
    contentTexts: props.contentTexts,
    inlineStyleJobFormArea: props.inlineStyleJobFormArea,
    theme: props.theme,
    inputTheme: props.inputTheme,
    inputErrorTheme: props.inputErrorTheme,
    flexDirection: props.flexDirection,
    flexJustify: props.flexJustify,
    buttonText: props.buttonText,
    className: props.className,
    hasPopularTrades: props.hasPopularTrades,
    buttonFill: props.buttonFill,
    showCancelButton: props.showCancelButton,
    cancelCallback: props.cancelCallback
  }, state)));
};

JobFormEntry.defaultProps = defaultProps;
export default JobFormEntry;